@if (!isAuthenticated() && !allowUnauthenticatedContent()) {
  <app-auth-connection-error />
} @else {
  <div class="shell" [class.shell--hide-nav]="hideNav()">
    <main class="shell__main" [@routeTransition]="routeKey()">
      <router-outlet />
    </main>

    @if (showNav()) {
      <nav
        class="nav"
        [class.nav--desktop]="hideNav()"
        aria-label="Main navigation"
      >
        <a class="nav__brand" routerLink="/home" aria-label="Bossing VIP home">
          <img src="assets/logo-bossing-vip.png" alt="Bossing VIP" width="160" height="37" />
        </a>
        @for (item of navItems; track item.path) {
          <a
            [routerLink]="item.path"
            class="nav__item"
            [class.nav__item--featured]="item.isCenter"
            [class.nav__item--active]="isNavActive(item)"
            [attr.aria-current]="isNavActive(item) ? 'page' : null"
          >
            @if (item.isCenter) {
              <span class="nav__fab">
                <span class="icon icon--star-solid icon--24" aria-hidden="true"></span>
              </span>
            } @else {
              <span [class]="navIconClass(item)" aria-hidden="true"></span>
            }
            <span class="nav__label">{{ item.label }}</span>
          </a>
        }
        <button type="button" class="nav__item nav__exit" (click)="backToTinbo()">
          <span class="icon icon--arrow-left-outline icon--24" aria-hidden="true"></span>
          <span class="nav__label">Back to TinBo</span>
        </button>
      </nav>
    }
  </div>
}
